export default __webpack_public_path__ + "static/media/schnips-login-logo.08bd5eff.png";